module.exports = __webpack_public_path__ + "static/img/11.bf15ba7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/zh/11.png
// module id = jlPP
// module chunks = 0